import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CreateAccountForm } from '../../features/users';
import {
  WatercraftAuthLayout,
  WatercraftHelmet,
} from '../../features/watercraft';
import {
  WATERCRAFT_INPUT_CLASS,
  WATERCRAFT_SUBMIT_BUTTON_CLASS,
} from '../../features/watercraft/styles';
import { WATERCRAFT_ROUTE } from '../../app/appConstants';
import { WATERCRAFT_LOGIN_ROUTE } from './constants';

export default function WatercraftCreateAccountPage(): React.JSX.Element {
  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get('redirect');
  const successRedirect = redirectParam ?? WATERCRAFT_ROUTE;
  const loginLink = redirectParam
    ? `${WATERCRAFT_LOGIN_ROUTE}?redirect=${encodeURIComponent(redirectParam)}`
    : WATERCRAFT_LOGIN_ROUTE;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <WatercraftHelmet />
      <WatercraftAuthLayout heading='Create your account'>
        <CreateAccountForm
          successRedirect={successRedirect}
          submitClassName={WATERCRAFT_SUBMIT_BUTTON_CLASS}
          inputClassName={WATERCRAFT_INPUT_CLASS}
          brandName='watercraft'
          newsSubscriptionLabel={null}
          signupSource='watercraft'
        />
        <p className='text-center text-sm font-medium text-watercraft-text-secondary'>
          Already have an account?{' '}
          <Link
            to={loginLink}
            className='font-semibold text-watercraft-accent underline'
          >
            Log in
          </Link>
        </p>
      </WatercraftAuthLayout>
    </>
  );
}
